import buildUrl from 'components/dashboard/buildUrl';
import {Link} from 'react-router';
import React from 'react';
import {HISTORY_ACTIONS} from 'components/StatsPage2.utils';

export function getFromPathState(fromPath) {
  return fromPath
    ? {
        pathname: fromPath,
        action: HISTORY_ACTIONS.PUSH,
      }
    : {};
}

export const ReviewLink = ({adminId, managerId, review, plan, fromPath, children}) => {
  const link = buildUrl({adminId, managerId}) + '/coaching-plans';
  const state = getFromPathState(fromPath);

  return (
    <Link
      to={{
        pathname: link,
        query: {
          repId: plan.recipient.id,
          planId: review.planId,
          reviewId: review.id,
        },
        state,
      }}>
      {children}
    </Link>
  );
};
